import { AuditedRVRequest } from "../../../api/entities";
import React, { Component } from "react";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import { getRVReqArea, getRVReqDate, getRVReqPropertyType, getRVReqStatus } from "./RVRequests";

export interface RVRequestsProps {
	requests: AuditedRVRequest[];
	onDetails: ( request: AuditedRVRequest ) => void;
}

class RVRequestsListView extends Component<RVRequestsProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { requests } = this.props;
		return <ListDataView
			items={ requests }
			renderListHeader={ () => <RenderHeader/> }
			renderListItem={ ( item: AuditedRVRequest ) => {
				return <RenderListItem
					key={ `rv_req_${ item.RequestNumber }` }
					request={ item }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: true,
				lengthChange: false
			} );
			const onDetails = this.props.onDetails;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onDetails( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.property_type }</th>
		<th>{ Strings.area }</th>
		<th>{ Strings.request_number }</th>
		<th>{ Strings.status }</th>
		<th>{ Strings.request_date }</th>
		<th>{ " " }</th>
	</tr>;
}

function RenderListItem( props: { request: AuditedRVRequest } ) {
	const { request } = props;
	return <tr>
		<td>{ getRVReqPropertyType( request ) }</td>
		<td>{ getRVReqArea( request ) }</td>
		<td>{ request.RequestNumber }</td>
		<td>{ getRVReqStatus( request ) }</td>
		<td>{ getRVReqDate( request ) }</td>
		<td>
			<a
				href="#"
				data-item={ JSON.stringify( request ) }>
				<i className="far fa-arrow-alt-circle-right"/>
			</a>
		</td>
	</tr>;
}

export default RVRequestsListView;
